import { useCallback } from 'react';

import useLinking from '@/hooks/useLinking';

import { BaseEventType } from '../../hooks/useBaseEvents/events';

export interface OpenLinkEventType extends BaseEventType {
  type: 'open-link';
  params: {
    getUrl?: string | (() => string);
  };
}

const useOpenLinkEvent = () => {
  const { openLink } = useLinking();

  return useCallback(
    (event: OpenLinkEventType) => {
      const { getUrl } = event.params;

      if (typeof getUrl === 'string') {
        openLink(getUrl);
      } else if (typeof getUrl === 'function') {
        openLink(getUrl());
      }
    },
    [openLink],
  );
};

export default useOpenLinkEvent;
